import React, { useEffect, useMemo, useState } from 'react';
import styles from './Home.module.scss';
import Carousel from '../../../molecule/carousel/Carousel';
import { useGetQuery } from '../../../../services/apiCall';
import endpoints from '../../../../api/endpoints';
import HomeSlider from './homeCarousel/HomeSlider/HomeSlider';
import { useDispatch } from 'react-redux';
import { setVolume } from '../../../../app/globals/slice/volume/VolumeState';
import { useMediaQuery } from 'react-responsive';

// const SECTION_ID = 0;
// const SECTION_ID_NEXT = 1;
const apiUrl = endpoints.homepage.get;

const checkData = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  return [];
};

const Home = ({ currentSection }) => {
  const isMobile = useMediaQuery({ maxWidth: 1200 });

  const dispatch = useDispatch();
  const { data, isLoading } = useGetQuery({ apiUrl });

  const [startX, setStartX] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [pauseVideo, setPauseVideo] = useState(false);
  const [pauseCarrousel, setPauseCarrousel] = useState(false);

  const slides = useMemo(() => {
    const arr = checkData(data);
    const sorted = arr.slice().sort((a, b) => {
      const sa = Number(a?.sequenceId ?? Number.POSITIVE_INFINITY);
      const sb = Number(b?.sequenceId ?? Number.POSITIVE_INFINITY);
      if (sa !== sb) return sa - sb;
      const ta = new Date(a?.createdOn ?? 0).getTime();
      const tb = new Date(b?.createdOn ?? 0).getTime();
      return ta - tb;
    });
    return sorted.map((item, index) => ({ ...item, index }));
  }, [data]);

  const componentsFromApi = useMemo(
    () =>
      slides.map((item, idx) => (
        <HomeSlider
          key={item?.id ?? idx}
          currentSection={currentSection}
          slideIndex={idx}
          item={item}
          currentSlide={currentSlide}
          setPauseVideo={setPauseVideo}
          pauseVideo={pauseVideo}
        />
      )),
    [slides, currentSection, currentSlide, pauseVideo]
  );

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    const swipeLength = startX - endX;
    const len = Math.max(slides.length, 1);

    if (swipeLength > 50) {
      setCurrentSlide((prev) => (prev + 1) % len);
    } else if (swipeLength < -50) {
      setCurrentSlide((prev) => (prev - 1 + len) % len);
    }
  };
  useEffect(() => {
    if (!Array.isArray(slides) || slides.length === 0 || isMobile) return;

    const seqOne = slides.find((x) => Number(x?.sequenceId) === 1);
    if (!seqOne) return;

    dispatch(setVolume(seqOne?.withSound ? 'on' : 'off'));
  }, [slides, dispatch]);

  // useEffect(() => {
  //   if (currentSection === 0 || currentSection === 1)
  //     setPauseCarrousel((prev) => {
  //       const next = currentSection !== 0;
  //       return prev === next ? prev : next;
  //     });
  // }, [currentSection]);

  return (
    <div
      className={styles.home}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {isLoading && !data ? (
        <></>
      ) : (
        <Carousel
          components={componentsFromApi}
          currentSlide={currentSlide}
          getSlide={(i) => setCurrentSlide(i)}
          dots={styles.homeDots}
          isArrowed={true}
          animation="fade"
          showAutoPlayControl
          autoPlayDefault
          autoPlayInterval={10000}
          fadeDuration={400}
          maxDots={10}
          onPauseClick={setPauseVideo}
          pauseCarrousel={pauseCarrousel}
        />
      )}
    </div>
  );
};

export default Home;
